/* src/app/components/custom-address-modal/custom-address-modal.component.scss */
.label {
  font-size: 300px;
}
.header {
  padding: 10px 17px;
  background-size: cover;
}
.header p {
  margin: 0;
}
.toolbar-logo {
  background: var(--ion-brand-logo-light);
  width: 50px;
  height: 50px;
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  display: flex;
  justify-self: center;
}
.back-icon {
  margin-right: 10px;
  width: 30px;
}
.ion-footer {
  background: #FFFFFF;
  color: var(--ion-color-second);
  text-align: center;
  cursor: pointer;
  border: 2px solid var(--ion-color-second);
  position: absolute;
  width: calc(100% - 100px) !important;
  margin: auto;
  left: 0;
  right: 0;
  bottom: 30px;
  z-index: 9999;
}
/*# sourceMappingURL=custom-address-modal.component.css.map */
